import React from "react";
import img1 from "images/rentaloption1.png";
import img2 from "images/rentaloption2.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useNavigate } from "react-router-dom";

const RentalOptions = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col md:flex-row gap-6 p-6">
      {/* First Card */}
      <div className="relative w-full md:w-1/2 rounded-2xl overflow-hidden">
        <img
          src={img1}
          alt="SUV for Rent"
          className="w-full h-64 md:h-80 object-cover"
        />
        <div className="absolute inset-0  flex flex-col justify-center p-6 text-white">
          <h2 className="text-3xl font-bold">In Need of a Luxury Ride?</h2>

          <ButtonPrimary
            onClick={() => {
              navigate("/vehicles");
            }}
            className="mt-4 text-white font-semibold py-2 px-4 rounded-full lg:max-w-fit"
          >
            Rent a Car
          </ButtonPrimary>
        </div>
      </div>

      {/* Second Card */}
      <div className="relative w-full md:w-1/2 rounded-2xl overflow-hidden">
        <img
          src={img2}
          alt="Event Cars for Rent"
          className="w-full h-64 md:h-80 object-cover"
        />
        <div className="absolute inset-0  flex flex-col justify-center p-6 text-white">
          <h2 className="text-3xl font-bold">Luxury Sprinter Van Services</h2>

          <ButtonPrimary
            onClick={() => {
              navigate("/events");
            }}
            className="mt-4 !bg-black  text-white font-semibold py-2 px-4 rounded-full lg:max-w-fit"
          >
            Rent a Van
          </ButtonPrimary>
        </div>
      </div>
    </div>
  );
};

export default RentalOptions;
